import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getApplication = async (id) => {
  const builder = new UrlBuilder(`/storages/get-application`);
  builder.add('applicationId', id);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const renameDocument = async (payload) => {
  const builder = new UrlBuilder(`/storages/rename-document`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
